var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"media-link",attrs:{"href":_vm.href,"target":"_blank"},on:{"click":_vm.checkCloseModalMenu}},[_c('SvgIconInline',{attrs:{"name":_vm.item.name}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }